
// eslint-disable-next-line no-unused-vars
const googleUser = {}

const sendDataOnSignIn = (getGoogleData) => {
  const [google_id, first_name, last_name, email] = getGoogleData
  document.querySelector('input[name=google_id]').value = google_id
  document.querySelector('input[name=first_name]').value = first_name
  document.querySelector('input[name=last_name]').value = last_name
  document.querySelector('input[name=email]').value = email

  $('.authorization__social').addClass('hidden')
  $('.authorization__google-connected, .authorization__social-connections').removeClass('hidden')
}

const getUserDataFromGoogle = (googleUser) => {
  //const profile = googleUser.getBasicProfile();
  const google_id = googleUser.sub //profile.getId();
  const first_name = googleUser.given_name //profile.getGivenName();
  const last_name = googleUser.family_name //profile.getFamilyName();
  const email = googleUser.email //profile.getEmail();
  // console.log(first_name, email, last_name, google_id);
  return [google_id, first_name, last_name, email]
}

const handleGoogleResponse = (response) => {
  const jwtParse = function (token) {
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    var jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            })
            .join('')
    )

    return JSON.parse(jsonPayload)
  }
  const payload = jwtParse(response.credential)
  //const googleBtn = document.getElementById('google-auth-custom');
  // const googleBtnText = googleBtn.querySelector('.google-auth__text');

  //googleBtnText.textContent = 'Signed in: ' + payload.given_name;

  sendDataOnSignIn(getUserDataFromGoogle(payload))
}

const initGoogleAuth = () => {
  // Retrieve the singleton for the GoogleAuth library and set up the client.
  // eslint-disable-next-line no-undef
  google.accounts.id.initialize({
    client_id: '56568939871-4es6j58su5977gsnqcuvtg0jvm0vcuol.apps.googleusercontent.com',
    callback: function (response) {
      const jwtParse = function (token) {
        var base64Url = token.split('.')[1]
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        var jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(function (c) {
                  return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
                })
                .join('')
        )

        return JSON.parse(jsonPayload)
      }
      const payload = jwtParse(response.credential)
      //const googleBtn = document.getElementById('google-auth-custom');
      //const googleBtnText = googleBtn.querySelector('.google-auth__text');

      //googleBtnText.textContent = 'Signed in: ' + payload.given_name;

      sendDataOnSignIn(getUserDataFromGoogle(payload))
    }
  })

  //attachSignin(document.getElementById('google-auth-custom'));
}

export {initGoogleAuth, handleGoogleResponse}
